import * as React from 'react';
import styles from './index.less';
import FComponentsLib from '@freelog/components-lib';
import { FI18n, FServiceAPI, FUtil } from '@freelog/tools-lib';
import fMessage from '@/components/fMessage';
import FUploadCover from '@/components/FUploadCover';
import FResourceLabelEditor from '@/components/FResourceLabelEditor';
import { connect } from 'dva';
import { CollectionCreatorPageModelState, ConnectState } from '@/models/connect';
import { Dispatch } from 'redux';
import {
  ChangeAction,
  OnChange_step4_resourceCover_Action,
  OnChange_step4_resourceLabels_Action,
  OnClick_step4_preBtn_Action,
  OnClick_step4_submitBtn_Action,
  Step4_Post_UpdateSetting_Action,
} from '@/models/collectionCreatorPage';
import FCoverImage from '@/components/FCoverImage';
import FInProcessModal from '@/components/FInProcessModal';
import { history } from 'umi';
import { UpdateStatesSettingBlock } from '@/pages/resource/collectionSidebar/info/$id';
import * as AHooks from 'ahooks';
import FHotspotTooltip, { fSetHotspotTooltipVisible } from '@/components/FHotspotTooltip';
import FIcons from '@/components/FIcons';

interface Step4Props {
  dispatch: Dispatch;
  collectionCreatorPage: CollectionCreatorPageModelState;
}

function Step4({ dispatch, collectionCreatorPage }: Step4Props) {

  const [$inProcessModal, set$inProcessModal] = FUtil.Hook.useGetState<boolean>(false);

  const { run } = AHooks.useDebounceFn(() => {
    dispatch<Step4_Post_UpdateSetting_Action>({
      type: 'collectionCreatorPage/step4_Post_UpdateSetting',
    });
  }, {
    wait: 300,
  });

  return (<>
    <div style={{ height: 40 }} />

    <div className={styles.block}>
      <FComponentsLib.FContentText
        // text={'合集封面'}
        text={FI18n.i18nNext.t('cqr_listing_image')}
        type={'highlight'}
      />
      <div style={{ height: 5 }} />
      <FComponentsLib.FContentText
        // text={'只支持JPG/PNG/GIF，GIF文件不能动画化，大小不超过5M，建议尺寸为800X600；未上传封面时，默认使用系统封面。'}
        text={FI18n.i18nNext.t('rqr_input_resouce_image_help')}
        type={'additional2'}
      />
      <div style={{ height: 20 }} />
      <FUploadCover
        onUploadSuccess={(url) => {
          dispatch<OnChange_step4_resourceCover_Action>({
            type: 'collectionCreatorPage/onChange_step4_resourceCover',
            payload: {
              value: url,
            },
          });
        }}
        onError={(err) => {
          fMessage(err, 'error');
        }}
      >
        {
          collectionCreatorPage.step4_resourceCover === '' && (<a className={styles.FUploadImageChildren}>
            <FIcons.FCloudUpload />
            <span>{FI18n.i18nNext.t('upload_image')}</span>
          </a>)
        }

        {
          collectionCreatorPage.step4_resourceCover !== '' && (<div className={styles.cover}>
            <FCoverImage src={collectionCreatorPage.step4_resourceCover} width={200} style={{ borderRadius: 4 }} />
            <div className={styles.coverEdit}>
              <FIcons.FEdit style={{ fontSize: 32 }} />
              <div style={{ height: 10 }} />
              <div>{FI18n.i18nNext.t('btn_edit_cover')}</div>
            </div>
          </div>)
        }
      </FUploadCover>
    </div>

    <div style={{ height: 5 }} />

    <div className={styles.block}>
      <FComponentsLib.FContentText
        text={FI18n.i18nNext.t('resource_short_description')}
        type={'highlight'}
      />
      <div style={{ height: 20 }} />
      <div>
        <FComponentsLib.FInput.FMultiLine
          value={collectionCreatorPage.step4_resourceIntroduction}
          lengthLimit={200}
          onChange={(e) => {
            // set$value(e.target.value);
            dispatch<ChangeAction>({
              type: 'collectionCreatorPage/change',
              payload: {
                step4_resourceIntroduction: e.target.value,
              },
            });
          }}
        />
      </div>
    </div>

    <div style={{ height: 5 }} />

    <UpdateStatesSettingBlock
      username={collectionCreatorPage.userInfo?.userName || ''}
      resourceID={''}
      value={collectionCreatorPage.step4_updateSetting}
      onChange={(value) => {
        dispatch<ChangeAction>({
          type: 'collectionCreatorPage/change',
          payload: {
            step4_updateSetting: value,
          },
        });
      }}
    />

    <div style={{ height: 5 }} />

    <div className={styles.block}>
      <FComponentsLib.FContentText
        // text={'合集标签'}
        text={FI18n.i18nNext.t('cqr_listing_tags')}
        type={'highlight'}
      />
      {/*<FComponentsLib.FContentText text={FI18n.i18nNext.t('rqr_input_resouce_tag')} type={'highlight'}/>*/}
      <div style={{ height: 20 }} />

      <FResourceLabelEditor
        value={collectionCreatorPage.step4_resourceLabels}
        // resourceType={resourceInfoPage.resourceInfo.resourceType[resourceInfoPage.resourceInfo.resourceType.length - 1 || 0]}
        resourceTypeCode={collectionCreatorPage.step1_createdResourceInfo?.resourceTypeCode || ''}
        onChange={(value) => {
          dispatch<OnChange_step4_resourceLabels_Action>({
            type: 'collectionCreatorPage/onChange_step4_resourceLabels',
            payload: {
              value: value,
            },
          });
        }}
      />
    </div>

    <div style={{ height: 30 }} />

    <div className={styles.btn}>

      <FComponentsLib.FTextBtn
        type={'default'}
        onClick={() => {
          // history.push(FUtil.LinkTo.resourceVersionInfo({
          //   resourceID: collectionCreatorPage.step1_createdResourceInfo?.resourceID || '',
          //   version: '1.0.0',
          // }));
          history.replace(FUtil.LinkTo.collectionVersionInfo({
            collectionID: collectionCreatorPage.step1_createdResourceInfo?.resourceID || '',
            // version: '1.0.0',
          }));
        }}
      >{FI18n.i18nNext.t('rqr_step3_btn_later')}</FComponentsLib.FTextBtn>

      <FComponentsLib.FTextBtn
        type={'default'}
        onClick={() => {
          dispatch<OnClick_step4_preBtn_Action>({
            type: 'collectionCreatorPage/onClick_step4_preBtn',
          });
        }}
      >{FI18n.i18nNext.t('cqr_step4_btn_back')}</FComponentsLib.FTextBtn>

      <FHotspotTooltip
        id={'collectionCreator.addResourceDrawer.createResourceButton'}
        style={{ left: 32, bottom: -38 }}
        zIndex={100}
        text={FI18n.i18nNext.t('hotpots_cqr_info_done')}
        onOpenChange={(o) => {
          if (o) {
            fSetHotspotTooltipVisible('collectionCreator.addResourceDrawer.createResourceButton', {
              value: false,
              effectiveImmediately: false,
              onlyNullish: false,
            });
          }
        }}
      >
        <FComponentsLib.FRectBtn
          disabled={collectionCreatorPage.step4_resourceIntroduction.length > 200 || collectionCreatorPage.step4_updateSetting.conditions.some((c) => {
            return c.value === '' || c.valueError !== '';
          })}
          type={'primary'}
          onClick={async () => {
            if (collectionCreatorPage.step3_policies.length > 0) {
              set$inProcessModal(true);
              await FUtil.Tool.promiseSleep(500);
            }
            dispatch<OnClick_step4_submitBtn_Action>({
              type: 'collectionCreatorPage/onClick_step4_submitBtn',
            });
          }}
        >{FI18n.i18nNext.t('cqr_step4_btn_release')}</FComponentsLib.FRectBtn>
      </FHotspotTooltip>
    </div>
    <div style={{ height: 200 }} />

    <FInProcessModal open={$inProcessModal} />
  </>);
}

export default connect(({ collectionCreatorPage }: ConnectState) => ({
  collectionCreatorPage: collectionCreatorPage,
}))(Step4);
